import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUserFromGoogle } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": session_id },
        });
        setUserFromGoogle(data.user, data.token);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUserFromGoogle]);

  return (
    <div className="min-h-[80vh] grid place-items-center">
      <div className="text-center">
        <div className="font-display text-3xl italic">Signing you in…</div>
        <div className="text-sm text-[color:var(--forest-2)] mt-2">One moment.</div>
      </div>
    </div>
  );
}
